/* Memorial · barra de búsqueda, cierre del buscador, "Los más pedidos" y filtro de presupuesto (no cambia ninguna URL) */
(function () {
  'use strict';
  var RANGOS = [
    { id: 'a', t: 'Hasta S/ 150', ok: function (p) { return p <= 150; } },
    { id: 'b', t: 'S/ 150 a S/ 300', ok: function (p) { return p > 150 && p <= 300; } },
    { id: 'c', t: 'Más de S/ 300', ok: function (p) { return p > 300; } }
  ];
  var FRASES = [
    'Busco una corona roja para mañana, hasta S/ 300',
    'Flores blancas para mi tía, presupuesto S/ 150',
    'Un manto de rosas rojas para hoy',
    'Lágrima azul hasta 250 soles',
    'Arreglo blanco con liliums hasta 200 soles'
  ];

  /* ---------- barra de búsqueda visible bajo el menú ---------- */
  function abrirBuscador(inicial) {
    var gatillos = document.querySelectorAll('[data-open-search-popup]');
    if (!gatillos.length) return;
    var g = gatillos[0];
    for (var i = 0; i < gatillos.length; i++) if (gatillos[i].offsetParent !== null) { g = gatillos[i]; break; }
    g.click();
    setTimeout(function () {
      var c = document.querySelector('[data-search-popup] [data-search-input]');
      if (!c) return;
      if (inicial) { c.value = inicial; c.dispatchEvent(new Event('input', { bubbles: true })); }
      c.focus();
    }, 220);
  }

  function iniciarBarra() {
    var barra = document.querySelector('[data-mm-barra]');
    if (!barra) return;
    var texto = barra.querySelector('[data-mm-barra-texto]');
    var boton = barra.querySelector('[data-mm-barra-abrir]');
    boton.addEventListener('click', function () { abrirBuscador(''); });
    Array.prototype.forEach.call(barra.querySelectorAll('[data-mm-atajo]'), function (b) {
      b.addEventListener('click', function () { abrirBuscador(b.getAttribute('data-mm-atajo')); });
    });
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, pos = 0, borrando = false, visible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0 }).observe(barra);
    function paso() {
      if (!visible || document.hidden) return setTimeout(paso, 900);
      var frase = FRASES[i];
      if (reducido) { texto.textContent = frase; i = (i + 1) % FRASES.length; return setTimeout(paso, 3200); }
      if (!borrando) {
        pos++; texto.textContent = frase.slice(0, pos) + '\u258d';
        if (pos >= frase.length) { borrando = true; return setTimeout(paso, 1900); }
        return setTimeout(paso, 55);
      }
      pos -= 2;
      if (pos <= 0) { pos = 0; borrando = false; i = (i + 1) % FRASES.length; texto.textContent = '\u258d'; return setTimeout(paso, 350); }
      texto.textContent = frase.slice(0, pos) + '\u258d';
      return setTimeout(paso, 22);
    }
    paso();
  }

  /* ---------- cerrar el buscador (X de escritorio) ---------- */
  function iniciarCierre() {
    document.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('.mm-cerrar-busqueda') : null;
      if (!x) return;
      e.preventDefault();
      var b = document.querySelector('.m-search-popup--header [data-close-search]');
      if (b) b.click();
    });
  }

  /* ---------- "Los más pedidos": filtros por tipo y "ver más" ---------- */
  function evento(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre }; for (var k in datos) o[k] = datos[k];
    window.dataLayer.push(o);
  }

  function iniciarPedidos() {
    var raiz = document.querySelector('[data-mm-pop]');
    if (!raiz) return;
    var grid = raiz.querySelector('[data-mm-pop-grid]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.mm-pop__card'));
    var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-filtro]'));
    var mas = raiz.querySelector('[data-mm-pop-mas]');
    var filtro = 'todos', limite = 8, expandido = false;

    chips.forEach(function (ch) {
      var f = ch.getAttribute('data-filtro');
      if (f !== 'todos' && !cards.some(function (c) { return c.getAttribute('data-cat') === f; })) ch.hidden = true;
    });

    function pintar() {
      var lista = cards.filter(function (c) { return filtro === 'todos' ? c.getAttribute('data-base') === '1' : c.getAttribute('data-cat') === filtro; });
      lista.sort(function (a, b) {
        return filtro === 'todos' ? (+a.getAttribute('data-pos') - +b.getAttribute('data-pos')) : (+a.getAttribute('data-rank') - +b.getAttribute('data-rank'));
      });
      cards.forEach(function (c) { c.hidden = true; });
      lista.forEach(function (c, i) { c.style.order = i; c.hidden = !expandido && i >= limite; });
      var resto = lista.length - limite;
      mas.hidden = expandido || resto <= 0;
      if (resto > 0) mas.textContent = 'Ver ' + resto + ' más';
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        filtro = ch.getAttribute('data-filtro'); expandido = false;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === ch ? 'true' : 'false'); });
        pintar();
        evento('mm_pedidos_filtro', { filtro: filtro });
      });
    });
    mas.addEventListener('click', function () { expandido = true; pintar(); evento('mm_pedidos_ver_mas', { filtro: filtro }); });
    grid.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.mm-pop__card') : null;
      if (a) evento('mm_pedidos_clic', { producto: a.getAttribute('data-handle'), posicion: a.getAttribute('data-pos'), tipo: a.getAttribute('data-cat') });
    });
    pintar();
  }

  var precios = null, activo = 'todos', cont = null, chipsEl = null, estadoEl = null, observador = null;

  function el(tag, clase, texto) { var e = document.createElement(tag); if (clase) e.className = clase; if (texto != null) e.textContent = texto; return e; }
  function lista() { var g = document.getElementById('CollectionProductGrid'); return g ? g.querySelector('.m-collection-products') : null; }
  function handleDe(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function aplicar() {
    var l = lista();
    if (!l || !precios) return;
    var r = null;
    RANGOS.forEach(function (x) { if (x.id === activo) r = x; });
    var vistos = 0, total = 0;
    Array.prototype.forEach.call(l.children, function (card) {
      var h = handleDe(card);
      if (!h) return;
      total++;
      var p = precios[h];
      var mostrar = !r || p == null || r.ok(p);
      card.style.display = mostrar ? '' : 'none';
      if (mostrar) vistos++;
    });
    if (estadoEl) estadoEl.textContent = r ? ('Mostrando ' + vistos + ' de ' + total) : '';
  }

  function marcar() {
    Array.prototype.forEach.call(chipsEl.querySelectorAll('button'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-id') === activo ? 'true' : 'false');
    });
  }

  function elegir(id) {
    activo = id;
    marcar(); aplicar();
    try {
      var u = new URL(window.location.href);
      if (id === 'todos') u.searchParams.delete('presupuesto'); else u.searchParams.set('presupuesto', id);
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  function construir() {
    var conteo = { todos: 0 };
    RANGOS.forEach(function (r) { conteo[r.id] = 0; });
    Object.keys(precios).forEach(function (h) { conteo.todos++; RANGOS.forEach(function (r) { if (r.ok(precios[h])) conteo[r.id]++; }); });
    var validos = RANGOS.filter(function (r) { return conteo[r.id] > 0; });
    if (validos.length < 2) return false;
    chipsEl.appendChild(chipNuevo('todos', 'Todos', conteo.todos));
    validos.forEach(function (r) { chipsEl.appendChild(chipNuevo(r.id, r.t, conteo[r.id])); });
    return true;
  }

  function chipNuevo(id, texto, n) {
    var b = el('button', 'mm-precio__chip'); b.type = 'button'; b.setAttribute('data-id', id);
    b.appendChild(document.createTextNode(texto));
    b.appendChild(el('span', 'mm-precio__n', String(n)));
    b.addEventListener('click', function () { elegir(id); });
    return b;
  }

  function iniciar() {
    cont = document.querySelector('[data-mm-precio]');
    if (!cont) return;
    var handle = cont.getAttribute('data-handle') || '';
    if (/^(menos-de|s-150|mas-de|rango-de)/.test(handle)) return;
    chipsEl = cont.querySelector('[data-mm-precio-chips]');
    estadoEl = cont.querySelector('[data-mm-precio-estado]');
    fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        precios = {};
        (j.products || []).forEach(function (p) { if (p.variants && p.variants.length) precios[p.handle] = parseFloat(p.variants[0].price); });
        var l = lista();
        if (!l || (parseInt(l.getAttribute('data-total-pages'), 10) || 1) > 1) return;
        if (!construir()) return;
        cont.hidden = false;
        var inicial = new URLSearchParams(window.location.search).get('presupuesto');
        activo = (inicial && RANGOS.some(function (r) { return r.id === inicial; })) ? inicial : 'todos';
        marcar(); aplicar();
        var g = document.getElementById('CollectionProductGrid');
        if (g && window.MutationObserver) { observador = new MutationObserver(function () { aplicar(); }); observador.observe(g, { childList: true, subtree: true }); }
      })
      .catch(function () {});
  }

  function todo() { iniciarCierre(); iniciarBarra(); iniciarPedidos(); iniciar(); }
  if (document.readyState !== 'loading') todo(); else document.addEventListener('DOMContentLoaded', todo);
})();
